import React from 'react';

export default function KoobTitle({ className, size = 'text-3xl', children }) {
  return <h3 className={`${size} font-bold text-k-h ${className}`}>{children}</h3>;
}
